import angular from 'angular';

angular
  .module('cloudX')
  .controller('YesNoCancelListDialogCtrl', [
    '$scope',
    'appMessages',
    'close',
    'title',
    'message',
    'items',
    yesNoCancelListDialogCtrl,
  ]);

function yesNoCancelListDialogCtrl($scope, appMessages, close, title, message, items) {
  $scope.title = appMessages(title);
  $scope.message = appMessages(message);
  $scope.items = items;
  $scope.close = function(result) {
    close(result, 500);
  };
  $scope.cancel = function() {
    close(null, 500);
  };
}
